import { api } from '@/api'

export default {
  // データを取得しエリアを与えられたグループIDにセットしタイマーをスタートする。
  init ({ commit, dispatch }, areaId) {
    dispatch('initIsDelivery')
    dispatch('initDashboardData')
    commit('setArea', areaId)
  },
  // 保存しているデータとタイマーをクリアする。
  clearData ({ commit, dispatch }) {
    dispatch('clearTimer')
    commit('setArea', null)
    commit('selectSpan', 0)
  },

  // 「データ取得時間」を現在時刻にセットし、１分ごとに「現在時刻」をアップデートするインターバルを開始する。
  startTimer ({ state, commit, dispatch }) {
    // 既にタイマーが存在していればクリアする。
    if (state.intervalId) {
      dispatch('clearTimer')
    }
    commit('setCurrentTimestamp', new Date().getTime())
    commit('setFetchedTimestamp', new Date().getTime())
    commit('setIntervalId', setInterval(() => {
      commit('setCurrentTimestamp', new Date().getTime())
    }, 1000 * 60))
  },
  // タイマーをクリアする。
  clearTimer ({ state, commit }) {
    clearInterval(state.intervalId)
    commit('setIntervalId', null)
    commit('setCurrentTimestamp', null)
    commit('setFetchedTimestamp', null)
  },

  // ダッシュボード用のデータを取得しVuexに保存する。
  async initDashboardData ({ commit, dispatch }) {
    commit('setLoading', true)
    commit('setChartLoader', true)
    commit('setWeatherInfoLoader', true)

    const { dashboards } = await api.getDashboard()
    const data = dashboards[0].components[0]

    if (data.type === 'Delivery') { // 配送員用
      commit('setLastUpdatedAt', data.lastUpdateDate)
      dispatch('initWeatherData', data.areas[0].weathers)
      dispatch('initTankInfo', data.areas[0].tankInfo)
      dispatch('initYesterdayData', data.areas[0].supplies[29])
      dispatch('initYearlyData', data.areas[0])
    } else { // それ以外
      commit('setWeeklyArray', data.weekly)
      commit('setMonthlyArray', data.monthly)
    }
    dispatch('startTimer')
    commit('setLoading', false)
    commit('setChartLoader', false)
    commit('setWeatherInfoLoader', false)
  },
  // ユーザーが配達員ならstateのisDeliveryをtrueにする。（ダッシュボード画面のコンポーネントが配送員専用のものになる。）
  initIsDelivery ({ rootState, commit }) {
    commit('setIsDelivery', rootState.app.user.roleId === 1)
  },
  // 現状天気予報が８日分届くため８日目をトリムして保存する。
  initWeatherData ({ commit }, weatherData) {
    if (!weatherData) return
    if (weatherData.length === 8) {
      weatherData = weatherData.slice(0, 7)
    }
    commit('setWeatherData', weatherData)
  },
  initTankInfo ({ commit }, { total, sensorInstalled }) {
    commit('setTankInfo', { total, installed: sensorInstalled })
  },
  initYesterdayData ({ commit }, { amount, count }) {
    commit('setYesterdayData', { amount, count })
  },
  initYearlyData ({ commit }, { thisYear, lastYear }) {
    commit('setYearly', [
      {
        amount: lastYear.amount,
        count: lastYear.count
      },
      {
        amount: thisYear.amount,
        count: thisYear.count
      }
    ])
  }
}
